import { render, staticRenderFns } from "./rBadge.vue?vue&type=template&id=7836394a&scoped=true"
import script from "./rBadge.vue?vue&type=script&lang=js"
export * from "./rBadge.vue?vue&type=script&lang=js"
import style0 from "./rBadge.vue?vue&type=style&index=0&id=7836394a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7836394a",
  null
  
)

export default component.exports